import type { Middleware, RequestContext } from "core/api/coreApiClient";

class CommandUrlFormatterMiddleware implements Middleware {
  pathOverride?: string;

  constructor(pathOverride?: string) {
    this.pathOverride = pathOverride;
  }

  pre = async (context: RequestContext) => {
    let { url } = context;

    // Commands endpoints are a dynamic path that is passed by the API.
    // We override that path by the given path.
    if (url.match("API_URL/__COMMANDS__/") !== null && this.pathOverride) {
      url = url.split("/__COMMANDS__/")[0] + this.pathOverride;
    }

    return await Promise.resolve({
      ...context,
      url,
    });
  };
}

export default CommandUrlFormatterMiddleware;
